import { render, staticRenderFns } from "./WarRoom.vue?vue&type=template&id=453448f4&"
import script from "./WarRoom.vue?vue&type=script&lang=js&"
export * from "./WarRoom.vue?vue&type=script&lang=js&"
import style0 from "./WarRoom.vue?vue&type=style&index=0&id=453448f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports